import { AppConsts } from '../../../../shared/AppConsts';
var GraphUtils = /** @class */ (function () {
    function GraphUtils() {
    }
    GraphUtils.getCustomStyleGraphUrl = function (graphSetting) {
        var graphUrl;
        if (!graphSetting || !graphSetting.id) {
            return '';
        }
        if (graphSetting.styles && graphSetting.styles.length > 0) {
            var style = this.getCustomStyle(graphSetting, 0);
            if (style != null) {
                graphUrl = AppConsts.remoteServiceBaseUrl + '/Gallary/GetImage?id=' + graphSetting.id
                    + '&fill=' + encodeURIComponent(style.fill)
                    + '&stroke=' + encodeURIComponent(style.stroke) + '&v=' + Math.floor(Date.now() / 1000);
            }
            else {
                graphUrl = AppConsts.remoteServiceBaseUrl +
                    '/Gallary/GetImage?id=' + graphSetting.id + '&v=' + Math.floor(Date.now() / 1000);
            }
        }
        else {
            graphUrl = AppConsts.remoteServiceBaseUrl +
                '/Gallary/GetImage?id=' + graphSetting.id + '&v=' + Math.floor(Date.now() / 1000);
        }
        return graphUrl;
    };
    GraphUtils.getCustomStyle = function (graphSetting, stateIndex) {
        if (graphSetting == null) {
            throw new Error("graphSetting can not be null or undefinded");
        }
        if (graphSetting.styles == null) {
            return null;
        }
        return graphSetting.styles.find(function (style) {
            if (style.version == null) {
                return style.state != null && +style.state === stateIndex;
            }
            {
                return style.stateIndex === stateIndex;
            }
        });
    };
    return GraphUtils;
}());
export { GraphUtils };
